module.exports = __webpack_public_path__ + "assets/img/bg2.25539a36.png";